<!--  -->
<template>
  <div class="specimen">
    <div class="specimen-list">
      <v-table :tableData="tableData"></v-table>
    </div>
    <!-- <v-page :event="getResult" @getList="getList" :showPagination="show" :limit="per_page" :totalPage="totalPage" :totalCount="specimensTotalCount"></v-page> -->
    <el-pagination @current-change="handleCurrentChange" :total="specimensTotalCount" :current-page="currentPage" :page-size="per_page" layout="prev,slot,next">
      <span class="rightPagination">
        {{currentPage}}/{{totalPage}}
      </span>
    </el-pagination>
  </div>
</template>

<script>
import { getSpecimens, updateSpecimens,utlogMap } from "@/api/index";
import { functionId} from '@/utils/browser.js';
import VTable from "@/components/table/specimen.vue";
import VPage from "@/components/pagenation/index.vue";

export default {
  name: "specimen",
  components: {
    VTable,
    VPage,
  },
  props: ["nodeId", "totalCount", "points"],
  data() {
    return {
      totalPage: 1,
      specimensTotalCount: 1,
      tableData: [],
      specimensData:[],
      per_page: 15,
      defaultPage: 1,
      currentPage: 1,
      routerName:'',
      tibetName:'TibetPlateau'
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.routerName = this.$route.name;
    if(this.routerName == this.tibetName) return;
    this.getSpecimens();
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.routerName == this.tibetName) {
        this.$set(this,'tableData',this.specimensData.slice(this.per_page*(val-1),this.per_page*val));
      } else {
        this.getSpecimens();
      }
      let logMap = {
        eventType: "clk",
        url: window.location.href,
        functionId: (this.routerName == this.tibetName) ?'Deepbone_tibet_specimensPageChange': 'Deepbone_explore_specimensPageChange',
      };
      utlogMap(logMap).then((res) => {
        // console.log(res);
      });
    },
    getResult(page) {
      return getSpecimens(this.nodeId, this.per_page, page);
    },
    getList(list) {
      this.$set(this, "tableData", list);
    },
    getSpecimens() {
      if (this.nodeId === "") return;
      getSpecimens(this.nodeId, this.per_page, this.currentPage).then((res) => {
        let data = res.data?.data || [];
        let meta = res.data?.meta || {};
        let { totalPage, totalCount } = meta;
        this.totalPage = totalPage;
        this.specimensTotalCount = totalCount;
        this.$emit("getTotalCount", totalCount);
        this.$set(this, "tableData", data);
      });
    },
    updateSpecimens(points) {
      let ids = [];
      points.forEach((point) => {
        let fossil_id = point?.properties?.fossil_id;
        if (fossil_id !== undefined) {
          ids.push(fossil_id);
        }
      });
      updateSpecimens(this.nodeId, ids).then((res) => {
        let data = res?.data?.data || [];
        this.$emit('updateGallery',data);
        this.totalPage = Math.ceil(data.length / this.per_page);
        this.specimensTotalCount = data.length;
        this.$emit("getTotalCount", this.specimensTotalCount);
        this.$set(this, "specimensData", data);//第一次获取全部的specimens数据
        this.$set(this,'tableData',this.specimensData.slice(0,this.per_page));
      });
    },
  },
  watch: {
    nodeId: function (newVal, oldVal) {
      if (this.routerName == this.tibetName) {
        return;
      }
      if (newVal != oldVal && newVal != "") {
        this.currentPage = 1;
        this.getSpecimens();
      }
    },
    points: function (val) {
      if (val) {
        this.updateSpecimens(val);
      }
    },
  },
};
</script>
<style>
.specimen {
  position: relative;
  padding-bottom: 40px;
  height: 800px;
  overflow: hidden;
}
.specimen-list {
  width: 100%;
  height: 100%;
  padding-bottom: 10px;
  overflow-y: scroll;
}
</style>
